import { render, staticRenderFns } from "./FloatingCartBox.vue?vue&type=template&id=25d52fd9"
import script from "./FloatingCartBox.vue?vue&type=script&lang=js"
export * from "./FloatingCartBox.vue?vue&type=script&lang=js"
import style0 from "./FloatingCartBox.vue?vue&type=style&index=0&id=25d52fd9&prod&slang=scss&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports